<template lang="pug">
  div(style="text-align:center")
    p
      img(src="images/logo_l.png" style="max-width:80%")
    .loginform
      .alert.alert-danger(v-if="error") {{error}}

      form(v-on:submit.prevent="onSubmit")
        p
          input#user_seito_id(autofocus="autofocus" placeholder="ログインID" required="required" type="text" v-model="condition.login_id" style="width:100%;font-size:20px;padding:10px;")
        p
          input#user_password(placeholder="パスワード" required="required" type="password" v-model="condition.password" style="width:100%;font-size:20px;padding:10px;")
        p(style="margin-top:30px;")
          button.btn.btn-primary(style="width:130px;" type="submit") ログイン

    p.text-right
      a(href='#/sign_up')
        strong 
          i.fa.fa-hand-point-right.mr-2
          | 初めての方はこちら
</template>

<script>

  import WtHttp from '@/components/WtHttp';
  // 生徒ログイン
  export default {
    name: 'SignIn',
    data() {
      return {
        error: null,
        condition: {login_id: "", password: ""}
      };
    },
    methods: {
      onSubmit() {
        WtHttp.post("./api/study/sign_in", {condition: this.condition})
          .then(response => {
            if (response.data.result == 'ok') {
              let user = response.data.user
              this.$store.commit('wt/user', { user: user })
              window.location.href = '#/study/top';
            } else {
              this.error = "ログインに失敗しました。ユーザIDまたはパスワードを確認してください。"
            }

          }, error => {
            this.error = "ログインに失敗しました。"
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
